import ReactPDF, { Path, Svg } from "@react-pdf/renderer";

export const CheckIconSVG = (p: ReactPDF.SVGProps & {
    color?: string;
}) => {
    // default is unchecked
    const { color = "#EFF1F5", ...rest } = p;
    return <Svg {...rest} width={15} height={15}>
        <Path fill-rule="evenodd" clip-rule="evenodd" d="M4.1022 7.41717C3.89491 7.19239 3.55072 7.18401 3.33344 7.39845C3.11615 7.61289 3.10805 7.96894 3.31534 8.19372L4.8696 9.90924C5.09185 10.1502 5.46674 10.1398 5.67612 9.88675L9.05408 5.48886C9.24937 5.25286 9.22273 4.89777 8.99459 4.69575C8.76645 4.49374 8.4232 4.52129 8.22792 4.7573L5.41567 8.45306C5.33311 8.56155 5.18117 8.58027 5.0763 8.49487C5.06654 8.48692 5.05739 8.47821 5.04892 8.46881L4.1022 7.41717ZM0.20813 7C0.20813 3.5625 2.92688 0.75 6.2498 0.75C9.57271 0.75 12.2915 3.5625 12.2915 7C12.2915 10.4375 9.57271 13.25 6.2498 13.25C2.92688 13.25 0.20813 10.4375 0.20813 7Z" fill={color} />
    </Svg>;
}